import { PureComponent } from "react";

import { BTPopover } from "@btnet/core-components/BTPopover";

import { recalculateAllFields } from "utilities/lineItem/markupUtility";

import { BTCheckbox } from "commonComponents/btWrappers/BTCheckbox/BTCheckbox";
import { BTFormItemAutomatic } from "commonComponents/btWrappers/BTForm/BTForm";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import { OwnerPriceCell } from "commonComponents/utilities/LineItemContainer/cellImplementations/OwnerPriceCell";

import { type ISelectionChoiceLineItem } from "entity/selectionChoice/SelectionChoiceLineItemContainer/SelectionChoiceLineItemContainer.types";
import { NoTaxId } from "entity/tax/TaxRate/TaxRate.api.types";

export interface ISelectionChoiceOwnerPriceCellProps extends ISelectionChoiceLineItem {
    isTBD: boolean;
    showSetPriceLater: boolean;
}

export class SelectionChoiceOwnerPriceCell extends PureComponent<
    IGridCellRenderProps<ISelectionChoiceOwnerPriceCellProps>
> {
    private handleTBDChange = () => {
        const { cellValue, onChange, field } = this.props;
        if (cellValue) {
            cellValue.isTBD = !cellValue.isTBD;
            cellValue.taxGroupId = NoTaxId;
            if (cellValue.isTBD) {
                cellValue.ownerPrice = 0;
                cellValue.markupAmount = 0;
                cellValue.markupPercent = 0;
                cellValue.margin = 0;
                cellValue.markupPerUnit = 0;
            } else {
                const calculatedValues = recalculateAllFields(cellValue);
                Object.assign(cellValue, calculatedValues);
            }
            onChange(field.path, { ...cellValue });
        }
    };

    render() {
        const { cellValue, field, isInEdit } = this.props;

        if (!cellValue) {
            return null;
        }

        const isTBDFieldName = `${field.path}.isTBD`;
        const isTBDComponent = (
            <BTCheckbox
                id={isTBDFieldName}
                data-testid={isTBDFieldName}
                checked={cellValue.isTBD}
                onChange={this.handleTBDChange}
            />
        );

        if (isInEdit) {
            return (
                <>
                    <OwnerPriceCell {...this.props} />
                    {cellValue.showSetPriceLater && (
                        <div className="tbdWrapper">
                            <BTFormItemAutomatic
                                id={isTBDFieldName}
                                className="RightAlignFormLabel tbdField"
                                label=""
                            >
                                {isTBDComponent}
                                <label className="tbdLabel">Set Price Later</label>
                                <BTPopover
                                    content="NOTE: Choice cannot be selected until price is entered"
                                    placement="right"
                                    className="tbdPopover"
                                />
                            </BTFormItemAutomatic>
                        </div>
                    )}
                </>
            );
        }

        return <OwnerPriceCell {...this.props} />;
    }
}
